import {
  siteCopy,
  type DemoBranch,
  type DemoChoiceId,
  type HowJourneyPanel,
  type HowJourneyStep,
  type Locale,
} from "./content.js";

export type { DemoBranch, DemoChoiceId, HowJourneyPanel, HowJourneyStep } from "./content.js";

export const howJourneySteps: readonly HowJourneyStep[] = siteCopy.zh.how.steps;
export const demoBranches: readonly DemoBranch[] = siteCopy.zh.story.branches;

export function localizedHowJourneySteps(locale: Locale): readonly HowJourneyStep[] {
  return siteCopy[locale].how.steps;
}

export function localizedDemoBranches(locale: Locale): readonly DemoBranch[] {
  return siteCopy[locale].story.branches;
}

export function demoBranch(choice: DemoChoiceId, locale: Locale = "zh"): DemoBranch {
  const branch = siteCopy[locale].story.branches.find((item) => item.id === choice);
  if (!branch) throw new Error("Unknown demo choice");
  return branch;
}
